import { render, staticRenderFns } from "./ClassNotification.vue?vue&type=template&id=1c7aba40"
import script from "./ClassNotification.vue?vue&type=script&lang=js"
export * from "./ClassNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports